// DateFormat  Request
export const formatPrice = (price) => {
    return "$" + Number(price).toLocaleString(undefined, { minimumFractionDigits: 2 });
}